<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
      <v-card-title class="headline">Réinitialisation du formulaire</v-card-title>
      <v-card-text>Toutes les données saisies vont être perdues. Etes-vous sûr(e) de vouloir continuer ?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn round flat @click="dialog = false">Annuler</v-btn>
        <v-btn round dark color="pink darken-1 elevation-2" @click="process">Réinitialiser</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      top
      color="green accent-4"
      multi-line
      v-model="processingSuccess">
      Le formulaire a été réinitialisé avec succès
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'ResetFormDialog',
    data () {
      return {
        dialog: false,
        processingSuccess: false
      }
    },
    methods: {
      process () {
        this.$parent.reset()
        this.dialog = false
        this.processingSuccess = true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Report/ResetFormDialog.vue